import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import WelcomeBanner from "./partials/hellobanner";
import Footer from "./Navbars/footer";
import { DashboardToolbar } from "../components/filters/DashboardToolbar";
import AdminAnalytics from "./AdminAnalytics";
import DeptRepAnalytics from "./DeptRepAnalytics";
import SupervisorActionCenter from "./SupervisorActionCenter";
import ManagerAnalytics from "./ManagerAnalytics";
import ApplicationSummary from "./information_cards/ApplicationSummary";
import { useDashboardData } from "../adapters/Requests";

function Dashboard() {
  const { auth } = useAuth();
  const perms = auth?.permissions || [];

  const [dateRange, setDateRange] = useState({
    from: undefined,
    to: undefined,
  });

  const adminViewPermissions = [
    "all",
    "admin",
    "verify",
    "approve",
    "accept",
    "delete",
  ];

  const isGlobalAdmin = perms.some((perm) =>
    adminViewPermissions.includes(perm),
  );

  const isDeptRep = perms.includes("assign_supervisor");
  const isSupervisor = perms.includes("supervise") && !isDeptRep;
  const isSecurity = perms.includes("security_view");
  const isManager = perms.includes("manage");

  // Single API call for the entire admin dashboard — only fires for admins
  const {
    data: dashboardData,
    isLoading: dashboardLoading,
    isError: dashboardError,
  } = useDashboardData(dateRange, isGlobalAdmin);

  const renderDashboardView = () => {
    if (isSecurity) {
      return <Navigate to="/security" replace />;
    }

    if (isGlobalAdmin) {
      return (
        <>
          <ApplicationSummary
            dashboardData={dashboardData}
            isLoading={dashboardLoading}
            isError={dashboardError}
          />
          <AdminAnalytics
            dashboardData={dashboardData}
            isLoading={dashboardLoading}
          />
        </>
      );
    }

    if (isManager) {
      return <ManagerAnalytics dateRange={dateRange} />;
    }

    if (isDeptRep) {
      return <DeptRepAnalytics dateRange={dateRange} />;
    }

    if (isSupervisor) {
      return (
        <SupervisorActionCenter userRole="supervisor" dateRange={dateRange} />
      );
    }

    return <Navigate to="/help" replace />;
  };

  const showFilters = isGlobalAdmin || isDeptRep || isManager || isSupervisor;

  return (
    <div className="bg-slate-50/50 min-h-screen pb-20">
      <div className="w-full max-w-[95%] 2xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="pb-4">
          <WelcomeBanner />
        </div>

        {showFilters && (
          <div className="flex justify-end mb-4 animate-in slide-in-from-top-2 duration-500">
            <div className="bg-white p-1 rounded-lg border border-slate-200 shadow-sm inline-block">
              <DashboardToolbar
                dateRange={dateRange}
                setDateRange={setDateRange}
              />
            </div>
          </div>
        )}

        <div className="animate-in slide-in-from-bottom-4 duration-700 fade-in mx-auto max-w-full">
          {renderDashboardView()}
        </div>

        <div className="mt-20 border-t border-slate-200 pt-8">
          {/* <Footer /> */}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
